import { IParamsApi } from '@/types/api/params.api';
import { IResponseApi } from '@/types/api/response.api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const cmsApiCaller = createApi({
  reducerPath: 'cmsApiCaller',
  refetchOnMountOrArgChange: 30,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_CMS_API_END_POINT,
  }),
  endpoints: (builder) => ({
    getHolidayBanner: builder.query<IResponseApi.IGetHolidayBanner, IParamsApi.IGetHolidayBanner>({
      query: (input) => {
        return {
          url: 'banner/active',
          method: 'GET',
          params: input,
        };
      },
    }),
  }),
});
